// import React from 'react'
// import { assets } from '../assets/assets'

// const Hero = () => {
//   return (
//     <div className='flex flex-col sm:flex-row border border-gray-400'>
//       {/* Hero Left Side */}
//       <div className='w-full sm:w-1/2 flex items-center justify-center py-10 sm:py-0'>
//             <div className='text-[#414141]'>
//                 <div className='flex items-center gap-2'>
//                     <p className='w-8 md:w-11 h-[2px] bg-[#414141]'></p>
//                     <p className=' font-medium text-sm md:text-base'>OUR BESTSELLERS</p>
//                 </div>
//                 <h1 className='prata-regular text-3xl sm:py-3 lg:text-5xl leading-relaxed'>Latest Arrivals</h1>
//                 <div className='flex items-center gap-2'>
//                     <p className='font-semibold text-sm md:text-base'>SHOP NOW</p>
//                     <p className='w-8 md:w-11 h-[1px] bg-[#414141]'></p>
//                 </div>
//             </div>
//       </div>
//       {/* Hero Right Side */}
//       <img className='w-full sm:w-1/2' src={assets.hero_img} alt="" />
//     </div>
//   )
// }

// export default Hero
// https://res.cloudinary.com/djqeoutoy/video/upload/v1736849004/kigt9qae3wwd2hcoi503.mp4

// // For Preorder Only below

// import React from 'react';
// import { Link } from 'react-router-dom';

// const Hero = () => {
//   const backgroundImage = 'https://res.cloudinary.com/djqeoutoy/image/upload/v1736336172/lhbqwgpkw2ifx8hr8ykc.png';
//   // const companyLogoUpper = 'https://res.cloudinary.com/djqeoutoy/image/upload/v1736317496/thvchjshphqfuzfr998m.png'; // Replace with your upper logo URL
//   // const companyLogoLower = 'https://res.cloudinary.com/djqeoutoy/image/upload/v1736317496/dthfm41t63kavw3jlz8p.png'; // Replace with your lower logo URL

//   return (
//     <div
//       className="relative w-full h-screen bg-cover bg-center"
//       style={{ backgroundImage: `url(${backgroundImage})`}}
//     >
//       {/* Logo Section
//       <div className="absolute inset-0 flex flex-col items-center justify-center space-y-4">
//         <img
//           src={companyLogoUpper}
//           alt="Logo Upper"
//           className="w-24 h-24 md:w-52 md:h-32"
//         />
//         <img
//           src={companyLogoLower}
//           alt="Logo Lower"
//           className="w-24 h-24 md:w-auto md:h-32"
//         />
//       </div> */}

//       {/* Text Section */}
//       <div className="absolute bottom-40 w-full text-center text-white space-y-4">
//       {/* <h1 className="text-2xl md:text-4xl font-jakarta mb-24 font-bold text-left ml-20  text-black">
//         Ancient Meet<span className="text-[#FF4902]"> Beyond</span>
//       </h1> */}
//         <Link to="/collection">
//           <button className="px-6 py-3 bg-[#FF4902]  text-white rounded-md text-lg hover:bg-orange-600 transition">
//             Pre-Order Now
//           </button>
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default Hero;

// below code for video showing

// import React, { useState, useEffect, useRef } from 'react';
// import { Helmet } from 'react-helmet-async';

// const videos = [
//   { url: 'https://res.cloudinary.com/djqeoutoy/video/upload/v1740658997/oaivobafgskosyb7jccv.mp4' },
//   { url: 'https://res.cloudinary.com/djqeoutoy/video/upload/v1740733979/xoehkcbb8oduf1micis3.mp4' },
//   { url: 'https://res.cloudinary.com/djqeoutoy/video/upload/v1740651124/qusb3jxhqarylzswxhvu.mp4' }

// ];

// function Hero() {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const intervalRef = useRef(null);

//   useEffect(() => {
//     startAutoSlide();
//     return () => stopAutoSlide();
//   }, []);

//   const startAutoSlide = () => {
//     intervalRef.current = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
//     }, 10000);
//   };

//   const stopAutoSlide = () => {
//     if (intervalRef.current) {
//       clearInterval(intervalRef.current);
//     }
//   };

//   const goToSlide = (index) => {
//     stopAutoSlide();
//     setCurrentIndex(index);
//     startAutoSlide(); // Restart the auto-slide after navigating manually
//   };

//   return (
//    <>
//     {/* SEO Metadata */}
//     <Helmet>
//     <title>Hero Page - Experience Ancient Meets Beyond</title>
//     <meta
//       name="description"
//       content="Explore the extraordinary blend of ancient heritage and modern vibes. Watch breathtaking videos that take you on a journey beyond the ordinary."
//     />
//     <meta
//       name="keywords"
//       content="hero page, ancient meets beyond, video slider, modern vibes, heritage videos"
//     />
//   </Helmet>
//     <div className="relative overflow-hidden w-full h-screen">
//       {/* Video Slides */}
//       <div
//         className="flex transition-transform duration-1000 ease-in-out"
//         style={{ transform: `translateX(-${currentIndex * 100}%)` }}
//       >
//         {videos.map((video, index) => (
//           <video
//             key={index}
//             src={video.url}
//             className="flex-shrink-0 object-cover w-full h-[80vh] sm:h-screen md:h-[90vh] lg:h-screen xl:h-screen"
//             autoPlay
//             loop
//             muted
//           />
//         ))}
//       </div>

//       {/* Large Text */}
//       <div className="absolute top-1/2 left-4 transform -translate-y-1/2">
//         <h1 className="text-white text-3xl sm:text-2xl md:text-4xl lg:text-5xl font-bold">
//           Ancient Meet <span className="text-[#FF4902]">Beyond</span>
//         </h1>
//       </div>

//       {/* Slide Dots */}
//       <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 ">
//         {videos.map((_, index) => (
//           <div
//             key={index}
//             onClick={() => goToSlide(index)}
//             className={`w-3 h-3 rounded-full cursor-pointer ${
//               currentIndex === index ? 'bg-[#FF4902]' : 'bg-white'
//             }`}
//           />
//         ))}
//       </div>
//     </div>
//     </>
//   );
// }

// export default Hero;

// import React, { useState, useEffect, useRef } from "react";
// import { Helmet } from "react-helmet-async";

// const videos = [
//   {
//     url: "https://res.cloudinary.com/dypkxqirq/video/upload/v1753356523/oaivobafgskosyb7jccv_2_1_tgphvb.mp4"
//   },
//   {
//     url: "https://res.cloudinary.com/dypkxqirq/video/upload/v1753355876/xoehkcbb8oduf1micis3_1_1_knsb7l.mp4"
//   },
//   {
//     url: "https://res.cloudinary.com/dypkxqirq/video/upload/v1753356956/qusb3jxhqarylzswxhvu_2_ost9vc.mp4"
//   }
// ];

// function Hero() {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const intervalRef = useRef(null);
//   const containerRef = useRef(null);
//   const startX = useRef(0);
//   const isDragging = useRef(false);

//   useEffect(() => {
//     startAutoSlide();
//     return () => stopAutoSlide();
//   }, []);

//   const startAutoSlide = () => {
//     intervalRef.current = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
//     }, 10000);
//   };

//   const stopAutoSlide = () => {
//     if (intervalRef.current) clearInterval(intervalRef.current);
//   };

//   const goToSlide = (index) => {
//     stopAutoSlide();
//     setCurrentIndex(index);
//     startAutoSlide();
//   };

//   // Handle Mouse & Touch Events
//   const handleDragStart = (e) => {
//     stopAutoSlide();
//     isDragging.current = true;
//     startX.current = e.touches ? e.touches[0].clientX : e.clientX;
//   };

//   const handleDragMove = (e) => {
//     if (!isDragging.current) return;
//     const currentX = e.touches ? e.touches[0].clientX : e.clientX;
//     const deltaX = currentX - startX.current;

//     if (deltaX > 50) {
//       setCurrentIndex((prevIndex) =>
//         prevIndex === 0 ? videos.length - 1 : prevIndex - 1
//       );
//       isDragging.current = false;
//       startAutoSlide();
//     } else if (deltaX < -50) {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % videos.length);
//       isDragging.current = false;
//       startAutoSlide();
//     }
//   };

//   const handleDragEnd = () => {
//     isDragging.current = false;
//   };

//   return (
//     <>
//       {/* SEO Metadata */}
//       <Helmet>
//         <title>Hero Page - Experience Ancient Meets Beyond</title>
//         <meta
//           name="description"
//           content="Explore the extraordinary blend of ancient heritage and modern vibes. Watch breathtaking videos that take you on a journey beyond the ordinary."
//         />
//         <meta
//           name="keywords"
//           content="hero page, ancient meets beyond, video slider, modern vibes, heritage videos"
//         />
//       </Helmet>

//       <div
//         className="relative overflow-hidden w-full h-screen"
//         ref={containerRef}
//         onMouseDown={handleDragStart}
//         onMouseMove={handleDragMove}
//         onMouseUp={handleDragEnd}
//         onMouseLeave={handleDragEnd}
//         onTouchStart={handleDragStart}
//         onTouchMove={handleDragMove}
//         onTouchEnd={handleDragEnd}
//       >
//         {/* Video Slides */}
//         <div
//           className="flex transition-transform duration-500 ease-in-out"
//           style={{ transform: `translateX(-${currentIndex * 100}%)` }}
//         >
//           {videos.map((video, index) => (
//             <video
//               key={index}
//               src={video.url}
//               className="flex-shrink-0 object-cover w-full h-[80vh] sm:h-screen md:h-[90vh] lg:h-screen xl:h-screen"
//               autoPlay
//               loop
//               muted
//             />
//           ))}
//         </div>

//         {/* Large Text */}
//         <div className="absolute top-1/2 left-4 transform -translate-y-1/2">
//           <h1 className="text-white text-3xl sm:text-2xl mt-44 md:text-4xl lg:text-5xl font-bold ">
//             Ancient Meet <span className="text-[#FF4902]">Beyond</span>
//           </h1>
//         </div>

//         {/* Slide Dots */}
//         <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
//           {videos.map((_, index) => (
//             <div
//               key={index}
//               onClick={() => goToSlide(index)}
//               className={`w-3 h-3 rounded-full cursor-pointer ${
//                 currentIndex === index ? "bg-[#FF4902]" : "bg-white"
//               }`}
//             />
//           ))}
//         </div>
//       </div>
//     </>
//   );
// }

// export default Hero;


// import React, { useState } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const HeroSlider = () => {
//   const images = [
//     {
//       url: "https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp",
//       title: "TED THE STONER",
//       subtitle: "THE SPLIT",
//     },
//     {
//       url: "https://res.cloudinary.com/dypkxqirq/image/upload/v1756976125/dark---web-siite-banner_mgstl0.webp",
//       title: "NEW DROP",
//       subtitle: "LIMITED EDITION",
//     },
//     {
//       url: "https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp",
//       title: "STREET STYLE",
//       subtitle: "FRESH LOOK",
//     },
//     {
//       url: "https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp",
//       title: "URBAN VIBES",
//       subtitle: "STAY TRENDY",
//     },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);

//   const prevSlide = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? images.length - 1 : prev - 1
//     );
//   };

//   const nextSlide = () => {
//     setCurrentIndex((prev) =>
//       prev === images.length - 1 ? 0 : prev + 1
//     );
//   };

//   return (
//     // <div className="relative w-full max-w-7xl mx-auto overflow-hidden">
//     <div className="relative w-full max-w-[1700px] mx-auto overflow-hidden">
//       {/* Slides */}
//       <div
//         className="flex transition-transform duration-700 ease-in-out"
//         style={{ transform: `translateX(-${currentIndex * 100}%)` }}
//       >
//         {images.map((img, index) => (
//           <div
//             key={index}
//             className="min-w-full h-[700px] relative flex items-center justify-center"
//             style={{
//               backgroundImage: `url(${img.url})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//             }}
//           >
//             <div className="absolute bottom-20 right-16 text-right">
//               <h2 className="text-yellow-400 text-3xl font-bold">
//                 {img.title}
//               </h2>
//               <p className="text-gray-200 text-lg">{img.subtitle}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Left Arrow */}
//       <button
//         onClick={prevSlide}
//         className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black"
//       >
//         <ChevronLeft size={24} />
//       </button>

//       {/* Right Arrow */}
//       <button
//         onClick={nextSlide}
//         className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black"
//       >
//         <ChevronRight size={24} />
//       </button>

//       {/* Dots */}
//       <div className="absolute bottom-5 w-full flex justify-center gap-2">
//         {images.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentIndex(index)}
//             className={`h-2 w-2 rounded-full ${
//               currentIndex === index ? "bg-white" : "bg-gray-400"
//             }`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HeroSlider;

// import React, { useState, useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const HeroSlider = () => {
//   // Define images for desktop and mobile separately
//   const images = [
//     {
//       desktop: "https://res.cloudinary.com/dypkxqirq/image/upload/v1756981206/THYNK-MAMMOTH-WEB-SITE-BANNER_iogw5h.webp",
//       mobile: "https://res.cloudinary.com/dypkxqirq/image/upload/v1756976125/dark---web-siite-banner_mgstl0.webp",
//       title: "TED THE STONER",
//       subtitle: "THE SPLIT",
//     },
//     {
//       desktop: "https://res.cloudinary.com/dypkxqirq/image/upload/v1756976125/dark---web-siite-banner_mgstl0.webp",
//       mobile: "https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp",
//       title: "NEW DROP",
//       subtitle: "LIMITED EDITION",
//     },
//     // {
//     //   desktop: "https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp",
//     //   mobile: "https://res.cloudinary.com/dypkxqirq/image/upload/v1756976125/dark---web-siite-banner_mgstl0.webp",
//     //   title: "STREET STYLE",
//     //   subtitle: "FRESH LOOK",
//     // },
//     // {
//     //   desktop: "https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp",
//     //   mobile: "https://res.cloudinary.com/dypkxqirq/image/upload/v1756976125/dark---web-siite-banner_mgstl0.webp",
//     //   title: "URBAN VIBES",
//     //   subtitle: "STAY TRENDY",
//     // },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);

//   // Detect screen size
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768); // sm & md = mobile
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Auto-slide every 3 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [images.length]);

//   const prevSlide = () => {
//     setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//   };

//   const nextSlide = () => {
//     setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//   };

//   return (
//     <div className="relative w-full max-w-[1700px] mx-auto overflow-hidden">
//       {/* Slides */}
//       <div
//         className="flex transition-transform duration-700 ease-in-out"
//         style={{ transform: `translateX(-${currentIndex * 100}%)` }}
//       >
//         {images.map((img, index) => (
//           <div
//             key={index}
//             className="min-w-full h-[500px] md:h-[650px] lg:h-[750px] relative flex items-center justify-center"
//             style={{
//               backgroundImage: `url(${isMobile ? img.mobile : img.desktop})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//             }}
//           >
//             <div className="absolute bottom-10 md:bottom-20 right-6 md:right-16 text-right">
//               <h2 className="text-yellow-400 text-xl md:text-3xl font-bold">
//                 {img.title}
//               </h2>
//               <p className="text-gray-200 text-sm md:text-lg">{img.subtitle}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Left Arrow */}
//       <button
//         onClick={prevSlide}
//         className="absolute left-3 md:left-6 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black"
//       >
//         <ChevronLeft size={24} />
//       </button>

//       {/* Right Arrow */}
//       <button
//         onClick={nextSlide}
//         className="absolute right-3 md:right-6 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black"
//       >
//         <ChevronRight size={24} />
//       </button>

//       {/* Dots */}
//       <div className="absolute bottom-4 md:bottom-6 w-full flex justify-center gap-2">
//         {images.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentIndex(index)}
//             className={`h-2 w-2 rounded-full ${
//               currentIndex === index ? "bg-white" : "bg-gray-400"
//             }`}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HeroSlider;

import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const HeroSlider = () => {
  const images = [
    {
      desktop:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1757052944/THYNK-MAMMOTH-WEB-SITE-BANNER_1_vkwfy9.webp",
      mobile:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1759995336/THYNK-MAMMOTH-WEB-SITE-PHONE_q6hpu6_1__11zon_clfrxi.webp",
      title: "",
      subtitle: "",
    },
    {
      desktop:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1757052944/dark---web-siite-banner_1_lswdrq.webp",
      mobile:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1759995337/phone-tenplate-web-site_jvp6n4_1_1__11zon_hbhzpo.webp",
      title: "",
      subtitle: "",
    },
    {
      desktop:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1757067525/28212_yzspl1.webp",
      mobile:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1759995337/WEB-SITE-BANNER-_PHONE-3_g2cwjz_1__11zon_xvenfj.webp",
      title: "",
      subtitle: "",
    },
    {
      desktop:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1757052944/womens-web-site-banner_kis50e.webp",
      mobile:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1759995337/womens-web-site-banner-mobile_xi2mrq_1__11zon_gdlfs7.webp",
      title: "",
      subtitle: "",
    },
    {
      desktop:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1757052944/NEW-KIDS-COLLECTION_n6es72.webp",
      mobile:
        "https://res.cloudinary.com/dypkxqirq/image/upload/v1759995337/NEW-KIDS--phone-web-site_gugsay_1__11zon_khednm.webp",
      title: "",
      subtitle: "",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-slide every 7 sec
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, 7000);
    return () => clearInterval(interval);
  }, [images.length]);

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section
      className="relative w-full overflow-hidden mt-0 p-0"
      aria-label="Hero Image Slider"
    >
      {/* Slides */}
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((img, index) => (
          <div
            key={index}
            className="min-w-full relative flex items-center justify-center mt-0 p-0"
          >
            <img
              src={isMobile ? img.mobile : img.desktop}
              alt={img.title}
              className="w-full h-[500px] md:h-[650px] lg:h-[750px] object-contain"
              loading="lazy"
            />
            <div className="absolute bottom-10 md:bottom-20 right-6 md:right-16 text-right px-4">
              <h2 className="text-yellow-400 text-xl md:text-3xl font-bold">
                {img.title}
              </h2>
              <p className="text-gray-200 text-sm md:text-lg">
                {img.subtitle}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Left Arrow */}
      <button
        onClick={prevSlide}
        aria-label="Previous slide"
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black focus:outline-none focus:ring-2 focus:ring-yellow-400"
      >
        <ChevronLeft size={24} />
      </button>

      {/* Right Arrow */}
      <button
        onClick={nextSlide}
        aria-label="Next slide"
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black focus:outline-none focus:ring-2 focus:ring-yellow-400"
      >
        <ChevronRight size={24} />
      </button>

      {/* Dots */}
      <div
        className="absolute bottom-4 md:bottom-6 w-full flex justify-center gap-2"
        role="group"
        aria-label="Slide navigation"
      >
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`h-2 w-2 rounded-full ${
              currentIndex === index ? "bg-white" : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;



// import React, { useState, useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";

// const HeroSlider = () => {
//   const images = [
//     {
//       desktop:
//         "https://res.cloudinary.com/dypkxqirq/image/upload/v1756981206/THYNK-MAMMOTH-WEB-SITE-BANNER_iogw5h.webp",
//       mobile:
//         "https://res.cloudinary.com/dypkxqirq/image/upload/v1756976125/dark---web-siite-banner_mgstl0.webp",
//     },
//     {
//       desktop:
//         "https://res.cloudinary.com/dypkxqirq/image/upload/v1756976125/dark---web-siite-banner_mgstl0.webp",
//       mobile:
//         "https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp",
//     },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isMobile, setIsMobile] = useState(false);

//   // Detect screen size
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Auto-slide every 3 sec
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prev) =>
//         prev === images.length - 1 ? 0 : prev + 1
//       );
//     }, 3000);
//     return () => clearInterval(interval);
//   }, [images.length]);

//   const prevSlide = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? images.length - 1 : prev - 1
//     );
//   };

//   const nextSlide = () => {
//     setCurrentIndex((prev) =>
//       prev === images.length - 1 ? 0 : prev + 1
//     );
//   };

//   return (
//     <section className="relative w-full overflow-hidden m-0 p-0">
//       {/* Slides */}
//       <div
//         className="flex transition-transform duration-700 ease-in-out"
//         style={{ transform: `translateX(-${currentIndex * 100}%)` }}
//       >
//         {images.map((img, index) => (
//           <div key={index} className="min-w-full relative flex items-start justify-center">
//             <img
//               src={isMobile ? img.mobile : img.desktop}
//               alt={`slide-${index}`}
//               className="w-full h-[500px] md:h-[650px] lg:h-[750px] object-contain"
//             />
//           </div>
//         ))}
//       </div>

//       {/* Left Arrow */}
//       <button
//         onClick={prevSlide}
//         className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black"
//       >
//         <ChevronLeft size={24} />
//       </button>

//       {/* Right Arrow */}
//       <button
//         onClick={nextSlide}
//         className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black"
//       >
//         <ChevronRight size={24} />
//       </button>

//       {/* Dots */}
//       <div className="absolute bottom-4 md:bottom-6 w-full flex justify-center gap-2">
//         {images.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentIndex(index)}
//             className={`h-2 w-2 rounded-full ${
//               currentIndex === index ? "bg-white" : "bg-gray-400"
//             }`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default HeroSlider;



